import { createContext, useCallback, useContext, useState } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  const login = useCallback((email) => {
    setUser({
      id: 1,
      name: "John Doe",
      email,
      avatar:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
    });
    setShowLogin(false);
  }, []);

  const register = useCallback((name, email) => {
    setUser({
      id: 1,
      name,
      email,
      avatar:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
    });
    setShowRegister(false);
  }, []);

  const logout = useCallback(() => setUser(null), []);
  const openLogin = useCallback(() => {
    setShowRegister(false);
    setShowLogin(true);
  }, []);
  const openRegister = useCallback(() => {
    setShowLogin(false);
    setShowRegister(true);
  }, []);
  const closeModals = useCallback(() => {
    setShowLogin(false);
    setShowRegister(false);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        showLogin,
        showRegister,
        login,
        register,
        logout,
        openLogin,
        openRegister,
        closeModals,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
